



















import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";

@Component({})
export default class ProgressSpinner extends Vue {
  @Prop({ default: 210 }) size!: number;
  @Prop({ default: 15 }) spinnerThickness!: number;
  @Prop({ default: "primary" }) spinnerColor!: string;
  @Prop({ default: "" }) textContent!: string;
  @Prop({ default: "white" }) textColor!: string;

  public get autoComponentStyle() {
    return {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "rgba(0, 0, 0, 0.15)",
      width: this.size / 4 + "vw",
      // height: this.height / 2 + "vh",
      borderRadius: "2%",
      justifyContent: "center",
      alignContent: "center"
    };
  }
  public get autoSpinnerColor() {
    if (this.spinnerColor) {
      return this.spinnerColor;
    }
    return this.$vuetify.theme.currentTheme.warning;
  }
  public get autoSpinnerThickness() {
    if (this.spinnerThickness === 15) {
      return this.size / 15;
    }
    return this.spinnerThickness;
  }
  public get autoFontStyle() {
    return {
      textAlign: "center",
      fontSize: this.size / 5 + "px",
      color: this.textColor
    };
  }
  public get autoLogoStyle() {
    return {
      display: "flex",
      justifyContent: "center",
      alignContent: "center"
    };
  }
  public get autoSpinnerPosition() {
    return {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      paddingBottom: this.size / 40 + "vh"
    };
  }
}
